import { render } from "./NFTsComp.vue?vue&type=template&id=7bc8be22"
import script from "./NFTsComp.vue?vue&type=script&lang=js"
export * from "./NFTsComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__